import { Howl } from 'howler';

interface TrackAliases {
  [key: string]: string;
}

class AudioManager {
  private _music: Howl;
  private tracks: string[];
  private trackAliases: TrackAliases = {
    '/audio/MariachiMadnessJimenaContreras.mp3': 'Mariachi',
    '/audio/ReadMyLipsTimeToPartyEveretAlmond.mp3': 'Dance'
  };

  constructor() {
    this.tracks = [
      '/audio/MariachiMadnessJimenaContreras.mp3',
      '/audio/ReadMyLipsTimeToPartyEveretAlmond.mp3'
    ];

    this._music = new Howl({
      src: this.tracks[0],
      loop: true,
    });
  }

  get music() {
    return this._music;
  }

  play() {
    this._music.play();
  }

  pause() {
    this._music.pause();
  }

  stop() {
    this._music.stop();
  }

  setSpeed(speed: number) {
    this._music.rate(speed);
  }

  getTracks() {
    return this.tracks;
  }

  getTrackAlias(track: string) {
    return this.trackAliases[track] || track;
  }

  setTrack(track: string) {
    this.stop();
    this._music = new Howl({
      src: [track],
      loop: true,
    });
  }
}

export default new AudioManager();